import { render, staticRenderFns } from "./AllocationPage.vue?vue&type=template&id=85220db8&scoped=true&"
import script from "./AllocationPage.vue?vue&type=script&lang=js&"
export * from "./AllocationPage.vue?vue&type=script&lang=js&"
import style0 from "./AllocationPage.vue?vue&type=style&index=0&id=85220db8&prod&lang=css&"
import style1 from "./AllocationPage.vue?vue&type=style&index=1&id=85220db8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85220db8",
  null
  
)

export default component.exports